import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';

const Info = ({ location, match }) => (
  <Redirect
    to={{
      pathname: `/schools/${match.params.sid}/school-newsletters`,
      state: { from: location.pathname },
    }}
  />
);

Info.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
    search: PropTypes.string.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      sid: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default Info;
